export default __webpack_public_path__ + "static/media/Landing_Elevate.7e8147d6.png";